<template>
  <div class="emergency-team">
    <Card>
      <Card :dis-hover="true" :bordered="false" :padding="0">
        <Row>
          <Form :label-width="100">
            <Col :span="4">
              <FormItem label="所属区县:">
                <Select transfer v-model="country" :disabled="countryList.length === 1" clearable style="width:200px"
                        @on-change="getEmergencyTeams" @on-clear="getEmergencyTeams">
                  <Option v-for="(item) in countryList" :key="item.id" :value="item.indexCode">{{ item.name }}</Option>
                </Select>
              </FormItem>
            </Col>
          </Form>
        </Row>
      </Card>
      <Row :gutter="4" style="margin-top: 10px">
        <Col :span="showMap ? 15 : 24">
          <Card :dis-hover="true" :padding="4" :bordered="false">
            <div @click="mapShow" v-if="!showMap"
                 style="background-color: #515a6e;position: absolute;top: 4px;right: 0;z-index: 999">
              <Icon type="ios-arrow-back" size="36" color="#fff"/>
            </div>
            <Table
                :loading="dataLoading"
                :columns="columns"
                :data="data"
                :border="false"
                :stripe="false"
                :highlight-current-row="true"
            >
              <template slot-scope="{ row, index }" slot="action">
                <el-button size="small" type="text" @click="view(row)">查看</el-button>
                <el-button size="small" type="text" @click="makeLocation(row)">定位</el-button>
              </template>
            </Table>
            <Page style="text-align: right;margin-top: 10px"
                  show-sizer
                  show-total
                  transfer
                  :total="dataTotal"
                  :page-size="pageSize"
                  :page-size-opts="pageSizeOpts"
                  :current-page="currentPage"
                  @on-change="pageChange"
                  @on-page-size-change="pageSizeChange"
            ></Page>
          </Card>
        </Col>
        <Col :span="showMap ? 9 : 0">
          <Card :dis-hover="true" v-if="showMap" :padding="0" style="position: relative">
            <div @click="mapShow" style="background-color: #515a6e;position: absolute;top: 4px;z-index: 999">
              <Icon type="ios-arrow-forward" size="36" color="#fff"/>
            </div>
            <div id="map" style="width: 100%;height: 600px"></div>
          </Card>
        </Col>
      </Row>
    </Card>
    <Modal v-model="viewModalIsShow" title="队伍" footer-hide :width="60">
      <h3 style="line-height: 60px;">队长信息</h3>
      <Table :data="dzData" :columns="dzColumns" :loading="dzLoading"></Table>
      <h3 style="line-height: 60px;">副队长信息</h3>
      <Table :data="fdzData" :columns="fdzColumns" :loading="fdzLoading" :height="200"></Table>
      <h3 style="line-height: 60px;">小队信息</h3>
      <Table :data="xdData" :columns="xdColumns" :loading="xdLoading" :height="200"></Table>
    </Modal>
  </div>
</template>

<script>
import { BMapLoader } from '@/utils/mapLoader'
import { columns, dzColumns, fdzColumns, xdColumns } from './js/columns'

export default {
  name: "emergencyTeam",
  data() {
    return {
      dzData: [],
      dzColumns,
      fdzData: [],
      fdzColumns,
      xdData: [],
      xdColumns,
      dzLoading: false,
      fdzLoading: false,
      xdLoading: false,
      viewModalIsShow: false,
      showMap: false,
      teamName: '',
      teamType: 0,
      superviseLevel: '',
      country: '',
      countryList: [],
      dataLoading: false,
      dataTotal: 0,
      columns,
      data: [],
      pageSize: 10,
      pageSizeOpts: [10, 20, 30, 40],
      currentPage: 1,
      curUserId: '',
      currentTeam: {}
    }
  },
  watch: {
    userInfo: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          console.log(newVal)
          this.curUserId = newVal.userId
        }
      }
    }
  },
  computed: {
    userInfo: {
      get: function () {
        console.log(this.$store)
        return this.$store.state.user.userInfo
      },
      set: function () {
      }
    }
  },
  mounted() {
    // this.initBMap()
    this.getEmergencyTeams()
    this.getCountry()
  },
  methods: {
    view(item) {
      console.log(item)
      this.viewModalIsShow = true
      this.currentTeam = item
      this.dzData = [item]
      this.getFdzData()
      this.getXdData()
    },
    // 获取副队长信息
    getFdzData() {
      this.fdzLoading = true
      this.$http.get(`/api/getAssistantCaptainsList/${this.currentTeam.fId}`).then(res => {
        if (res.status === 200) {
          this.fdzLoading = false
          this.fdzData = res.data
        }
      })
    },
    // 获取小队信息
    getXdData() {
      this.xdLoading = true
      this.$http.get(`/api/getEmergencyRanksTeamsList/${this.currentTeam.fId}`).then(res => {
        if (res.status === 200) {
          this.xdLoading = false
          this.xdData = res.data
        }
      })
    },
    initBMap() {
      BMapLoader(this.$mapConfigKey).then(BMap => {
        const map = new BMap.Map('map', { enableMapClick: false })
        this.map = map
        this.BMap = BMap
        map.disableKeyboard() // 禁用键盘操作地图
        map.enableScrollWheelZoom(true) // 开启鼠标滚轮缩放
        // 添加中心点和缩放等级，如果不添加，初始化出来页面为白屏
        // const point = new BMap.Point(116.36555, 37.44131)
        map.centerAndZoom('德州市', 12)
        // var marker = new BMap.Marker(point)
        // this.map.addOverlay(marker);
        // var lat = Number(row.emergencyTeam.longitude) // 经度
        // var lng = Number(row.emergencyTeam.dimension) // 纬度
        // var point = new this.BMap.Point(lng, lat)
        // var marker = new this.BMap.Marker(point)
        // map.addOverlay(marker);
        // map.centerAndZoom(point, 16)
      })
    },
    makeLocation(row) {
      this.showMap = true
      BMapLoader(this.$mapConfigKey).then(BMap => {
        const map = new BMap.Map('map', { enableMapClick: false })
        this.map = map
        this.BMap = BMap
        map.disableKeyboard() // 禁用键盘操作地图
        map.enableScrollWheelZoom(true) // 开启鼠标滚轮缩放
        this.map.centerAndZoom('德州市', 12)
      })
      if (row.longitude === null && row.latitude === null) {
        // this.$Message.error("该队伍未设置坐标")
        return;
      }
      var lat = Number(row.longitude) // 经度
      var lng = Number(row.latitude) // 纬度
      var point = new this.BMap.Point(lng, lat)
      var marker = new this.BMap.Marker(point)
      this.map.addOverlay(marker);
      this.map.centerAndZoom(point, 16)
    },
    mapShow() {
      this.showMap = !this.showMap
      this.initBMap()
    },
    gotoAdd() {
      this.$router.push({
        name: 'addEmTeam'
      })
    },
    editTeam(row) {
      this.$router.push({
        name: 'addEmTeam',
        params: {
          row: row
        }
      })
    },
    gotoDetail(row) {
      this.$router.push({
        name: 'emTeamDetail',
        params: {
          row: row
        }
      })
    },
    gotoSend(row) {
      this.$router.push({
        name: 'sendTeam',
        params: {
          row: row
        }
      })
    },
    gotoHistory(row) {
      this.$router.push({
        name: 'sendHistory',
        params: {
          row: row
        }
      })
    },
    deleteTeam(row) {
      // this.$http.get(`/api/team/delete/${row.emergencyTeam.id}`).then(res => {
      //   console.log(res)
      //   this.getEmergencyTeams()
      // })
    },
    //区县
    getCountry() {
      this.$http.get('/api/getLowerLevelDepts?flag=4').then(res => {
        console.log(res)
        this.countryList = res.data
        if (this.countryList.length === 1) {
          this.country = res.data[0].indexCode
        }
      })
    },
    //获取应急队伍列表 /api/team/getTeams
    getEmergencyTeams() {
      this.dataLoading = true
      let params = {
        teamType: this.teamType === 0 ? '' : this.teamType,
        superviseLevel: this.superviseLevel,
        name: this.teamName,
        unit: this.country === '' ? null : this.country
      }
      this.$http.post(`/api/getEmergencyRanksCaptainsList?page=${this.currentPage}&&size=${this.pageSize}`, params).then(res => {
        console.log(res)
        this.data = res.data.data
        this.dataTotal = res.data.recordsTotal
        this.dataLoading = false
      })
    },
    tagChange(value) {
      // console.log(value)
      this.getEmergencyTeams()
    },
    pageChange(page) {
      this.currentPage = page
      this.getEmergencyTeams()
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.getEmergencyTeams()
    }
  }
}
</script>

<style scoped lang="less">
.emergency-team {
  .my-label {
    text-align: right;
  }

  .ivu-radio-group-item {
    margin-left: 16px;
  }
}
</style>
